import { createSlice } from "@reduxjs/toolkit";
import { encryptFun, getItemFromStorage, removeItemFromStorage, setItemToStorage } from "../utils/helper";
import { STORAGE_KEYS } from "../config/config";

const getInitialState = () => ({
  token: null,
  refreshToken: null,
  userInfo: null,
  rememberMe: false,
  credential: null,
});

// const getInitialState = () => ({
//   token: getItemFromStorage(STORAGE_KEYS.TOKEN),
//   refreshToken: getItemFromStorage(STORAGE_KEYS.REFRESH_TOKEN),
//   userInfo: getItemFromStorage(STORAGE_KEYS.USER)
//     ? JSON.parse(getItemFromStorage(STORAGE_KEYS.USER))
//     : getItemFromStorage(STORAGE_KEYS.USER),
//   rememberMe: getItemFromStorage(STORAGE_KEYS.REMEMBER_ME) ? true : true,
//   credential: getItemFromStorage(STORAGE_KEYS.CREDENTIAL),
// });

export const userSlice = createSlice({
    name: "user",
    initialState: getInitialState(),
    reducers: {
      setLoginData: (state, action) => {
        state.token = action.payload.token;
        state.refreshToken = action.payload.refreshToken;
        state.userInfo = action.payload.user;
        setItemToStorage(STORAGE_KEYS.TOKEN, action.payload.token);
        setItemToStorage(STORAGE_KEYS.REFRESH_TOKEN, action.payload.refreshToken);
        setItemToStorage(
          STORAGE_KEYS.USER,
          action.payload.user
        );
        state.rememberMe = action.payload.rememberMe ? true : false;
        if (action.payload.rememberMe) {
          const credential = encryptFun({
            username: action.payload.username,
            password: action.payload.password,
          });
          state.credential = credential;
          setItemToStorage(STORAGE_KEYS.CREDENTIAL, credential);
        } else {
          state.credential = null;
          removeItemFromStorage(STORAGE_KEYS.REMEMBER_ME);
          removeItemFromStorage(STORAGE_KEYS.CREDENTIAL);
        }
      },
      setRefreshToken: (state, action) => {
        state.refreshToken = action.payload.refreshToken;
        setItemToStorage(STORAGE_KEYS.REFRESH_TOKEN, action.payload.refreshToken);
      },
      setUserInfo: (state, action) => {
        state.userInfo = action.payload.userInfo;
        setItemToStorage(STORAGE_KEYS.USER, action.payload.userInfo);
      },
      setRememberMe: (state) => {
        state.rememberMe = !state.rememberMe;
        setItemToStorage(STORAGE_KEYS.REMEMBER_ME, `${state.rememberMe}`);
      },
      setToken: (state, action) => {
        state.token = action.payload.token;
        setItemToStorage(STORAGE_KEYS.TOKEN, action.payload.token);
      },
      setCredential: (state, action) => {
        state.credential = action.payload.credential;
        setItemToStorage(STORAGE_KEYS.CREDENTIAL, action.payload.credential);
      },
      setLogout: (state) => {
        state.token = null;
        state.refreshToken = null;
        state.userInfo = null;
        removeItemFromStorage(STORAGE_KEYS.TOKEN);
        removeItemFromStorage(STORAGE_KEYS.REFRESH_TOKEN);
        removeItemFromStorage(STORAGE_KEYS.USER);
        removeItemFromStorage(STORAGE_KEYS.REMEMBER_ME);
        removeItemFromStorage(STORAGE_KEYS.CREDENTIAL);
      },
    },
  });
  
  export const { setLoginData, setRememberMe, setToken, setCredential, setRefreshToken, setUserInfo } = userSlice.actions;
  export const selectUserData = (state) => state.userInfo;
  
  export default userSlice.reducer;